import { connect } from 'react-redux';
import { withLocalize } from 'react-localize-redux';
import {
    changePopupDialog,
    chartLinesChanged,
    chartLoaded,
    chartMetricSelected,
    filtersExpanded,
    hideChart,
    pivotChartChanged,
    reportsFieldClicked,
    reportsFieldSet,
    searchFilterChanged,
    setActionType,
    showChart,
    toggleFieldsAvailability,
    updateChartData,
    updateChartShowLegend,
    updateQueryURL,
} from 'actions/reports';
import {
    getActiveBookmarkName,
    getCustomFieldGroupLabels,
    getFieldGroupsToHide,
    getIsEditShelfOpen,
    getPopupDialogParams,
    getReportsFilters,
    getSelectedFields,
    getShowPopupDialog,
    reportDataSelectors,
} from 'selectors/reports';

import Reports from 'components';
import { getAdminModeEnabled, getFieldsAvailabilityEnabled, isShelfReporting, showPivotCharts } from 'selectors/user';
import { getEmptyStateOrgData } from 'selectors/onboarding';
import { onCloseReportsEmptyState } from 'actions/onboarding';

let reportType = '';
let getReportsData;

const mapStateToProps = (state, ownProps) => {
    if (ownProps.type !== reportType) {
        reportType = ownProps.type;
        getReportsData = reportDataSelectors[reportType];
    }

    const reportData = getReportsData(state);

    return {
        ...reportData,
        user: state.user,
        permissionKeys: state.user.data.permission_keys,
        reportType,
        adminMode: getAdminModeEnabled(state),
        customFieldGroupLabels: getCustomFieldGroupLabels()(state),
        fieldGroupsToHide: getFieldGroupsToHide()(state),
        showPivotCharts: showPivotCharts(state),
        activeBookmarkName: getActiveBookmarkName(reportType)(state),
        showFieldsAvailabilityFeature: getFieldsAvailabilityEnabled(state, reportType),
        reportFilters: getReportsFilters(state, reportType)(),
        showPopupDialog: getShowPopupDialog(state, reportType)(),
        popupDialogParams: getPopupDialogParams(state, reportType)(),
        emptyStateOrgData: getEmptyStateOrgData(state),
        isEditShelfOpen: getIsEditShelfOpen(state, reportType)(),
        isShelfReporting: isShelfReporting(state, reportType),
        selectedFields: getSelectedFields(state, reportType)(),
    };
};

const mapDispatchToProps = dispatch => {
    return {
        onFieldClick: (...args) => dispatch(setActionType(reportsFieldClicked(...args), reportType)),
        onFieldSet: (...args) => dispatch(setActionType(reportsFieldSet(...args), reportType)),
        onChartLinesChanged: value => dispatch(chartLinesChanged(reportType, value)),
        onChartLegendToggle: show => dispatch(setActionType(updateChartShowLegend(show, reportType), reportType)),
        onChartMetricSelected: (metric, chartParams) =>
            dispatch(setActionType(chartMetricSelected(metric, chartParams), reportType)),
        onChartLoaded: chartParams => dispatch(setActionType(chartLoaded(chartParams), reportType)),
        onToggleChart: show =>
            show ? dispatch(setActionType(showChart(), reportType)) : dispatch(setActionType(hideChart(), reportType)),
        onPivotChartChange: chartSettings => dispatch(setActionType(pivotChartChanged(chartSettings), reportType)),
        onUpdateQueryURL: () => dispatch(setActionType(updateQueryURL(reportType), reportType)),
        onFieldsAvailabilityClick: (field, isOpen) =>
            dispatch(setActionType(toggleFieldsAvailability(field, isOpen), reportType)),
        changePopupDialog: (isOpen, params) => dispatch(setActionType(changePopupDialog(isOpen, params)), reportType),
        onCloseReportsEmptyState: () => dispatch(onCloseReportsEmptyState()),
        onFiltersExpand: isExpanded => dispatch(setActionType(filtersExpanded(isExpanded), reportType)),
        onSearchFilterChanged: isActive => dispatch(setActionType(searchFilterChanged(isActive), reportType)),
        onUpdateChartData: () => dispatch(updateChartData(reportType)),
    };
};

export default withLocalize(connect(mapStateToProps, mapDispatchToProps)(Reports));
